import { Skeleton } from "./skeleton";
import { TableCell, TableRow } from "./table";

export const SkeletonTableBody = ({ pageSize, columnsLength }: { pageSize: number; columnsLength: number }) => (
  <>
    {Array.from({ length: pageSize }).map((_, index) => (
      <TableRow key={index}>
        {Array.from({ length: columnsLength }).map((_, cellIndex) => (
          <TableCell key={cellIndex}>
            <Skeleton className="h-4 w-full" />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);
